module.exports = __webpack_public_path__ + "static/media/locate-charging-stations.048220db.svg";